module.exports = __webpack_public_path__ + "img/course_guide_1.0740b96d.png";